import type { FC } from "react";
import { DDSBodyText, DDSButton, DDSHeadlineText, DDSLogo, DDSOtpInput } from "@web-monorepo/dds";
import { ErrorMessage, ResendCodeButton } from "./components";

import imgSrc from "./letter.png";
import styles from "./VerificationPage.module.css";
import { useViewModel } from "./VerificationPage.vm";

export type Props = {
  error: unknown;
  onCode(code: string | null): void;
  entityType: "teacher" | "parent";
  // needed for context
  // eslint-disable-next-line react/no-unused-prop-types
  onCancel: () => void;
  fullscreen?: boolean;
};

const instructionsId = "one_time_code.verification.label.id";

const VerificationPage: FC<Props> = ({ entityType, error, onCode, fullscreen }) => {
  const vm = useViewModel({ entityType, onCode, error });

  return (
    <>
      {fullscreen && (
        <nav className={styles.nav}>
          <DDSLogo brand="classdojo" variant="mark" className={styles.mojo} />
        </nav>
      )}
      <div className={styles.content}>
        <img src={imgSrc} alt="email icon" />
        <DDSHeadlineText as="h1" className={styles.headline} id={instructionsId}>
          Enter the 6-digit code
        </DDSHeadlineText>
        {vm.instructions && (
          <DDSBodyText as="span" className={styles.instructions}>
            {vm.instructions}
          </DDSBodyText>
        )}
        <form className={styles.form} onSubmit={vm.handleSubmit}>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus -- deliberate a11y tradeoff: this screen exists solely to enter the one-time code, so focusing the field on mount is the expected, desired behavior. (DDSOtpInput's autoFocus runs a programmatic .focus() in a useEffect.) */}
          <DDSOtpInput formError={vm.formHasError} onChange={vm.handleChange} labeledBy={instructionsId} autoFocus />
          <ErrorMessage for={error} className={styles.error} />

          <DDSButton
            data-name="otp_entry.verify_code"
            variant="primary"
            size="large"
            type="submit"
            disabled={!vm.canSubmit}
            width="fit"
          >
            Verify
          </DDSButton>

          {/* Calling onCode with null is the same as firing the original request which retriggers an email*/}
          <ResendCodeButton onClick={() => onCode(null)} />
        </form>
      </div>
    </>
  );
};

export default VerificationPage;
